import { Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng-lts/api';
import { PropertyService } from '../../properties/property.service';
import { ProfileService } from '../../../services/profile.services';
import { take } from 'rxjs/operators';
import { BaseDirectiveObject } from '../../components/common/base-directive-object';
import { AppConfiguration } from '../../conf/app.configuration';
import { UserService } from '../../user.service';


@Injectable()
export class DossierLinkService extends BaseDirectiveObject implements OnDestroy {

  VER_PREGUNTAS: boolean;
  calendarEnabled = true;
  cliente: any;
  constructor(
    public translateService: TranslateService,
    private propertyService: PropertyService,
    private profileService: ProfileService,
    private appConfig: AppConfiguration,
    private userService: UserService
  ) {
    super();

    this.calendarEnabled = true;

    this.cliente = this.appConfig.getValue('cliente');

    if (this.appConfig.getValue('calendar.enabled.profiles') !== undefined
      && !this.userService.hasRoles(this.appConfig.getValue('calendar.enabled.profiles'))
    ) {
      this.calendarEnabled = false;
    }
    this.subscribe(

      this.propertyService.getProperty('VER_PREGUNTAS_LICITACION', '1')

      ,
      (result) => {
        this.VER_PREGUNTAS = result === '1';
      }
    );
  }

  ngOnDestroy(): void {
    this.subscriptionUtils.unregisterAllSubscriptions();
  }
  // Lista de acciones de expediente que se muestran en el desplegable de una tarea
  getDossierLinks(identifier: string, separator: boolean, documentClass: string): Array<MenuItem> {

    let mn: MenuItem = {};
    let items: MenuItem[] = [];



    mn = <MenuItem>{};
    mn.label = this.translateService.instant('DossierInfo.sections.GENERAL_INFO.short');
    mn.separator = separator;
    mn.icon = 'fa fa-info-circle';
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: 'GENERAL_INFO' };
    items.push(mn);


    mn = <MenuItem>{};
    mn.label = this.translateService.instant('DossierInfo.sections.DOSSIER_ACTIONS.short');
    mn.icon = 'fa fa-tasks';
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: 'DOSSIER_ACTIONS' };
    items.push(mn);

    mn = <MenuItem>{};
    mn.label = this.translateService.instant('DossierInfo.sections.CONTRACTS.short');
    mn.icon = 'fa fa-file-contract';
    mn.routerLink = ['/dossierInfo', identifier];

    if ('AYMAD' === this.cliente) {
      mn.queryParams = { component: 'CONTRACTSAYMAD' };
    } else {
      mn.queryParams = { component: 'CONTRACTS' };
    }
    items.push(mn);

    mn = <MenuItem>{};
    mn.label = this.translateService.instant('DossierInfo.sections.DOCUMENTS.short');
    mn.icon = 'fa fa-file-alt';
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: 'DOCUMENTS' };
    items.push(mn);


    mn = <MenuItem>{};
    mn.label = this.translateService.instant('DossierInfo.sections.ACCOUNTING.short');
    mn.icon = 'fa fa-euro-sign';
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: 'ACCOUNTING' };
    items.push(mn);

    mn = <MenuItem>{};
    mn.label = this.translateService.instant('DossierInfo.sections.COMMUNICATIONS.short');
    mn.icon = 'fa fa-envelope-open-text';
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: 'COMMUNICATIONS' };
    items.push(mn);


    if (this.VER_PREGUNTAS) {
      mn = <MenuItem>{};
      mn.label = this.translateService.instant('DossierInfo.sections.QUESTIONS.short');
      mn.icon = 'fa fa-question-circle';
      mn.routerLink = ['/dossierInfo', identifier];
      mn.queryParams = { component: 'QUESTIONS' };
      items.push(mn);

    }


    if (this.profileService.isOptionEnabled('PLANNING', documentClass)) {

      mn = <MenuItem>{};
      mn.label = this.translateService.instant('DossierInfo.sections.PLANNING.short');
      mn.icon = 'fa fa-clock';
      mn.routerLink = ['/dossierInfo', identifier];
      mn.queryParams = { component: 'PLANNING' };
      items.push(mn);
    }

    mn = <MenuItem>{};
    mn.label = this.translateService.instant('DossierInfo.sections.PROCEDURES.short');
    mn.icon = 'fa fa-list-ul';
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: 'PROCEDURES' };
    items.push(mn);

    mn = <MenuItem>{};
    mn.label = this.translateService.instant('DossierInfo.sections.AUDIT.short');
    mn.icon = 'fa fa-lg fa-list-ul';
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: 'AUDIT' };
    items.push(mn);
    if (this.calendarEnabled) {
      mn = <MenuItem>{};
      mn.label = this.translateService.instant('DossierInfo.sections.CALENDAR.short');
      mn.icon = 'fa fa-calendar';
      mn.routerLink = ['/dossierInfo', identifier];
      mn.queryParams = { component: 'CALENDAR' };
      items.push(mn);
    }

    return items;
  }


  getDossierContractLinks(identifier: string, separator: boolean): Array<MenuItem> {



    let mn: MenuItem = {};
    let items: MenuItem[] = [];

    mn = <MenuItem>{};
    this.translateService.get('DossierInfo.sections.GENERAL_INFO.short').pipe(take(1)).subscribe((res: string) => {
      mn.label = res;
    });
    mn.separator = separator;
    mn.icon = 'fa fa-info-circle';
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: 'GENERAL_INFO' };
    items.push(mn);


    mn = <MenuItem>{};
    this.translateService.get('DossierInfo.sections.DOSSIER_ACTIONS.short').pipe(take(1)).subscribe((res: string) => {
      mn.label = res;
    });
    mn.icon = 'fa fa-tasks';
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: 'DOSSIER_ACTIONS' };
    items.push(mn);

    mn = <MenuItem>{};
    this.translateService.get('DossierInfo.sections.CONTRACTS.short').pipe(take(1)).subscribe((res: string) => {
      mn.label = res;
    });
    mn.icon = 'fa fa-file-contract';
    mn.routerLink = ['/dossierInfo', identifier];
    if ('AYMAD' === this.cliente) {
      mn.queryParams = { component: 'CONTRACTSAYMAD' };
    } else {
      mn.queryParams = { component: 'CONTRACTS' };
    }
    items.push(mn);


    mn = <MenuItem>{};
    this.translateService.get('DossierInfo.sections.DOCUMENTS.short').pipe(take(1)).subscribe((res: string) => {
      mn.label = res;
    });
    mn.icon = 'fa fa-file-alt';
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: 'DOCUMENTS' };
    items.push(mn);



    mn = <MenuItem>{};
    this.translateService.get('DossierInfo.sections.COMMUNICATIONS.short').pipe(take(1)).subscribe((res: string) => {
      mn.label = res;
    });
    mn.icon = 'fa fa-envelope-open-text';
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: 'COMMUNICATIONS' };
    items.push(mn);



    mn = <MenuItem>{};
    this.translateService
      .get('DossierInfo.sections.PROCEDURES.short')
      .pipe(take(1))
      .subscribe((res: string) => {
        mn.label = res;
      });
    mn.icon = 'fa fa-list-ul';
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: 'PROCEDURES' };
    items.push(mn);

    mn = <MenuItem>{};
    this.translateService.get('DossierInfo.sections.AUDIT.short').pipe(take(1)).subscribe((res: string) => {
      mn.label = res;
    });
    mn.icon = 'fa fa-lg fa-list-ul';
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: 'AUDIT' };
    items.push(mn);
    if (this.calendarEnabled) {
      mn = <MenuItem>{};
      this.translateService.get('DossierInfo.sections.CALENDAR.short').pipe(take(1)).subscribe((res: string) => {
        mn.label = res;
      });
      mn.icon = 'fa fa-calendar';
      mn.routerLink = ['/dossierInfo', identifier];
      mn.queryParams = { component: 'CALENDAR' };
      items.push(mn);
    }
    return items;
  }

}
